import { effectScope } from "#imports";
import { isVueI18n, getComposer } from "../../compatibility.js";
import { localeHead } from "../compatibles/head.js";
import {
  getRouteBaseName,
  localeLocation,
  localePath,
  localeRoute,
  resolveRoute,
  switchLocalePath
} from "../compatibles/routing.js";
import { wrapComposable } from "../../internal.js";
import { initCommonComposableOptions } from "../../utils.js";
export function extendI18n(i18n, { extendComposer, extendComposerInstance }) {
  const scope = effectScope();
  const installI18n = i18n.install.bind(i18n);
  i18n.install = (app, ...options) => {
    const pluginOptions = Object.assign({}, options[0]);
    pluginOptions.inject ??= true;
    pluginOptions.__composerExtend = (c) => {
      extendComposerInstance(c, getComposer(i18n));
      return () => {
      };
    };
    if (i18n.mode === "legacy") {
      pluginOptions.__vueI18nExtend = (vueI18n) => {
        extendComposerInstance(vueI18n, getComposer(vueI18n));
        return () => {
        };
      };
    }
    Reflect.apply(installI18n, i18n, [app, pluginOptions]);
    const globalComposer = getComposer(i18n);
    scope.run(() => {
      extendComposer(globalComposer);
      if (i18n.mode === "legacy" && isVueI18n(i18n.global)) {
        extendComposerInstance(i18n.global, getComposer(i18n.global));
      }
    });
    if (i18n.mode === "composition" && app.config.globalProperties.$i18n != null) {
      extendComposerInstance(app.config.globalProperties.$i18n, globalComposer);
    }
    if (pluginOptions.inject) {
      const common = initCommonComposableOptions(i18n);
      app.mixin({
        methods: {
          $getRouteBaseName: wrapComposable(getRouteBaseName, common),
          $resolveRoute: wrapComposable(resolveRoute, common),
          $localePath: wrapComposable(localePath, common),
          $localeRoute: wrapComposable(localeRoute, common),
          $localeLocation: wrapComposable(localeLocation, common),
          $switchLocalePath: wrapComposable(switchLocalePath, common),
          $localeHead: wrapComposable(localeHead, common)
        }
      });
    }
    if (app.unmount) {
      const unmountApp = app.unmount.bind(app);
      app.unmount = () => {
        scope.stop();
        unmountApp();
      };
    }
  };
  return scope;
}
